import { useEffect, useState } from "react";
import { searchLensCatalog } from "../lens-library.js";
import { useLensApp } from "../useLensApp.jsx";
import LensCardRail from "./LensCardRail.jsx";

export default function FavoritesShelf() {
  const { favorites, favoriteIds, activeLenses, busyLensId, favoriteError, actions } = useLensApp();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [searchError, setSearchError] = useState("");
  const activeLensId = String(activeLenses[0]?.lensId || "");
  const trimmedQuery = query.trim();

  useEffect(() => {
    if (trimmedQuery.length < 3) {
      setResults([]);
      setSearching(false);
      setSearchError("");
      return undefined;
    }
    const controller = new AbortController();
    const timer = window.setTimeout(() => {
      setSearching(true);
      setSearchError("");
      searchLensCatalog({ query: trimmedQuery, pageSize: 36, signal: controller.signal })
        .then((result) => setResults(result.lenses))
        .catch((error) => {
          if (error.name !== "AbortError") setSearchError(error.message);
        })
        .finally(() => {
          if (!controller.signal.aborted) setSearching(false);
        });
    }, 220);
    return () => {
      window.clearTimeout(timer);
      controller.abort();
    };
  }, [trimmedQuery]);

  const searchingActive = trimmedQuery.length >= 3;
  const lenses = searchingActive ? results : favorites;

  return (
    <section className="favorites-shelf">
      <div className="section-heading-row">
        <div>
          <h3>Lenses</h3>
          <div className="hint flush">Favorites and catalog search</div>
        </div>
        <a className="text-link" href="/ui/lenses/">Browse</a>
      </div>
      <input
        className="favorites-search"
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder="Search lenses or categories"
        aria-label="Search lenses or categories"
      />
      {(searchError || favoriteError) && <div className="inline-error">{searchError || favoriteError}</div>}
      {searching && <div className="favorites-status">Searching…</div>}
      {!searching && trimmedQuery.length > 0 && trimmedQuery.length < 3 && (
        <div className="favorites-status">Enter at least three characters.</div>
      )}
      {lenses.length
        ? (
          <LensCardRail
            lenses={lenses}
            favoriteIds={favoriteIds}
            activeLensId={activeLensId}
            busyLensId={busyLensId}
            onApply={actions.toggleCatalogLens}
            onFavorite={actions.toggleFavorite}
          />
        )
        : (!searching && !searchingActive ? (
          <a className="favorites-empty" href="/ui/lenses/">
            Star lenses to keep them close at hand.
            <span>Browse lenses →</span>
          </a>
        ) : (!searching && <div className="favorites-empty">No matching lenses.</div>))}
    </section>
  );
}
